import React from 'react';

export const stopEventPropagation = (event: React.SyntheticEvent) => {
  event.preventDefault();
  event.stopPropagation();
  event.nativeEvent.stopImmediatePropagation();
};
